export enum UserCredentialType {
  EMAIL_PASSWORD = 0,
}
